const DEVICE_ID_KEY = 'magma_device_id';

const getDeviceId = (): string => {
  try {
    const existingDeviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (existingDeviceId) {
      return existingDeviceId;
    }

    const generatedDeviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, generatedDeviceId);

    return generatedDeviceId;
  } catch {
    return 'unknown-device';
  }
};

export {
  getDeviceId,
};
